import React from "react";
import {
  Typography,
  Card,
  CardActionArea,
  CardHeader,
  CardContent,
  CardMedia
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {} from "@material-ui/core/colors";

const useStyles = makeStyles({
  card: {
    maxWidth: 500,
    float: "right"
  },
  media: {
    height: 400 // necessory for card image
  },
  cardHeader: {
    backgroundColor: "#3F51B5",
    color: "#FFFFFF"
  }
});

export const StokeTreatment = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="h3">Treatment of ischemic stroke</Typography>
      <ul>
        <li>— alteplase to start within 4.5 hours of symptom onset</li>
        Refer to IV tPA Screening Checklist 
        <br/>
        Before tpa/thrombolytic therapy is started, the blood pressure should keep
        &lt; or equal 180/105 mmHg for at least 24 hours.
        <li>— Mechanical thrombectomy with in 24 hrs of symptoms onset if patien has large vessel occlusion</li>
        <li>— Asa/plavix within 48 hours of stroke onset, DVT prevention, Bp and statin therapay</li>
        <li>— risk factors modification such as</li>
        smoking/Alcohol Atrial fibration (need anticoagulant if CHA2DS2 score &gt; or = 1 in male and &gt; or = 2 in
        female) Diabetes ( the goal is less than 7% of HbA1c) Uncontrolled Bp, cholesterol Exercise Weight oss if
        obesity Diet change if need Illegal drugs Ischemia — There are three main subtypes of brain ischemia:
        <ul>
          <li>Thrombosis: Thrombus formed in karger vessel or small vessel</li>
          <li>Embolism: multiple acute stroke due to plaques from multiple possible source</li>
          <li>Systemic hypoperfusion</li>
        </ul>
      </ul>
      <Typography variant="body1">Risk factor BP control</Typography>
      <Typography variant="body1">Ischemic stroke</Typography>
      <Typography variant="body1">
        Not treated with tpa, Bp should be treated Sbp &gt;220 mmHg or DBp &gt;120 mmHg), But if pt has active CAD, CHF,
        aortic dissection, or pre-eclampsia/eclampsia, if treatment is indicated, then lower BP by 15 percent during the
        first 24 hours
      </Typography>
      <Typography variant="body1">
        Start treatment for HTN with &gt; 140/90 in 24-48 hrs after onset stroke, the goal is to control Bp in a few
        days to a week. However, if is a different criteria if patient has intracranial or extracranial artery stenosis.
      </Typography>
      <Typography variant="body1">Start treatment HTN with S Bp &lt; 130 with small vessel stroke</Typography>
      <Typography variant="body1">
        Start treatment HTN with S Bp &lt; 120 and help decrease any type of stroke by 41%
      </Typography>
      <Typography variant="body1">Blood pressure in acute hemorrhagic stroke</Typography>
      <ul>
        <li>Lower Sbp less than 140 if Sbp 150-220</li>
        <li>Lower Bp 140-160 if Sbp &gt; 220</li>
      </ul>
    </div>
  );
};
